
export default {
    version: '0.0.0',
};
